import { render } from "./DispensarReceta.vue?vue&type=template&id=8c2a9908&scoped=true"
import script from "./DispensarReceta.vue?vue&type=script&lang=js"
export * from "./DispensarReceta.vue?vue&type=script&lang=js"

import "./DispensarReceta.vue?vue&type=style&index=0&id=8c2a9908&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2a9908"]])

export default __exports__